import React, {useEffect, useRef, useState} from "react";
import {GoogleMap as Map, useJsApiLoader, Marker, Autocomplete} from "@react-google-maps/api";
import TextField from "../TextField/TextField";
import locationIcon from "../../../assets/locationIcon.png";
import Button from "../../molecules/Button";
import {FiSearch} from "react-icons/fi";

function GoogleMap({
    inputValue,
    setInputValue,
    onLoad,
    onUnmount,
    closeModal,
    zoom,
    marker,
    open,
    businessesLocation,
    noRadius,
    noSearchField,
    showAddress,
    dirrection,
    btn = true,
    handlePlace,
    ...rest
}) {
    const [searchValue, setSearchValue] = useState(inputValue);
    const [markerPosition, setMarkerPosition] = useState(null);
    const ref = useRef(null);
    const {isLoaded} = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: "AIzaSyARhFVFYkqqbvJ1moa2_73JMEa8Z5LeVaM",
        libraries: ["places"],
    });
    const sampleDestination = {
        latitude: 51.0447,  // Calgary, Alberta, Canada
        longitude: -114.0719,
    };
    useEffect(() => {
        if (!inputValue) {
            const {latitude, longitude} = sampleDestination;
            setMarkerPosition({lat: latitude, lng: longitude});
        } else {
            fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
                    inputValue
                )}&key=AIzaSyARhFVFYkqqbvJ1moa2_73JMEa8Z5LeVaM`
            )
                .then(response => response.json())
                .then(data => {
                    if (data.results && data.results.length > 0) {
                        const location = data.results[0].geometry.location;
                        setMarkerPosition({lat: location.lat, lng: location.lng});
                    }
                })
                .catch(error => {
                    console.error("Error fetching geocode:", error);
                });
        }
    }, [inputValue]);

    const containerStyle = {
        width: "100%",
        height: "300px",
        borderRadius: noRadius ? "0" : "30px",
        backgroundColor: "#000",
    };

    const options = {
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: true,
        zoomControl: false,
        keyboardShortcuts: false,
    };
    const handlePlaceSelect = place => {
        if (place.geometry && place.geometry.location) {
            const newMarkerPosition = {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
            };
            setMarkerPosition(newMarkerPosition);
            setSearchValue(place.formatted_address);
            setInputValue(place);
            handlePlace(place);
        }
    };

    const handleMapClick = event => {
        const clickedLat = event.latLng.lat();
        const clickedLng = event.latLng.lng();
        setMarkerPosition({lat: clickedLat, lng: clickedLng});

        fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${clickedLat},${clickedLng}&key=AIzaSyARhFVFYkqqbvJ1moa2_73JMEa8Z5LeVaM`
        )
            .then(response => response.json())
            .then(data => {
                if (data.results && data.results.length > 0) {
                    const address = data.results[0].formatted_address;
                    console.log(data.results[0].name);
                    setSearchValue(address);
                    setInputValue(address);
                }
            })
            .catch(error => {
                console.error("Error fetching address:", error);
            });
    };

    return isLoaded ? (
        <>
            {noSearchField ? (
                ""
            ) : (
                <Autocomplete
                    className="map-list"
                    onLoad={autocomplete =>
                        autocomplete.addListener("place_changed", () => handlePlaceSelect(autocomplete.getPlace()))
                    }
                    options={{componentRestrictions: { country: "CA" } }}>

                    <div className="input map-input">
                        <TextField
                            type="text"
                            placeholder="Search location"
                            name="address"
                            hasicon={<FiSearch />}
                            value={searchValue}
                            onChange={e => {
                                setSearchValue(e.target.value);
                                setInputValue(e.target.value);
                            }}
                        />
                    </div>
                </Autocomplete>
            )}
            <Map
                {...rest}
                ref={ref}
                zoom={zoom || 15}
                onLoad={onLoad}
                onUnmount={onUnmount}
                mapContainerStyle={containerStyle}
                center={markerPosition}
                options={options}
                onClick={handleMapClick}>
                {markerPosition && (
                    <Marker position={markerPosition} icon="../images/OrderCheckout/primary-user-icon.svg" />
                )}
            </Map>
            {showAddress && (
                <div className="location-holder">
                    {searchValue && <img src={locationIcon} alt="icon" />}
                    <span>{searchValue}</span>
                </div>
            )}
            {btn && (
                <div className="btn-search-wrap">
                    <Button
                        width="343px"
                        type={searchValue !== "" ? "primary" : "secondary"}
                        className="btn-search"
                        onClick={() => closeModal()}>
                        Save Address
                    </Button>
                </div>
            )}
        </>
    ) : (
        <div className="loading-map-outer">
            <span class="loader"></span>
            <p>Loading Map ...</p>
        </div>
    );
}

export default GoogleMap;
